import React from 'react';
import { Container, Row, Col } from 'bootstrap-4-react';
import sample1 from '../images/portfolio/mtn-home.png';
import sample2 from '../images/portfolio/homepage.png';
import sample4 from '../images/portfolio/4.png';
import portfolioHero from "../images/portfolio-hero.jpg";
import Slide from 'react-reveal/Slide';
import HeroSection from '../Components/HeroSection/HeroSection';
import Header from '../Header/Header';
import "./PortfolioPage.css";
import Footer from '../Footer/Footer';
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Link } from "react-router-dom";


class PortfolioPage extends React.Component {

    componentDidMount() {
        ReactGA.pageview('/case-studies/');
    }
    render() {
        window.scrollTo(0, 0);
        return (
            <div className="portfolio-page">
                <Header />
                <HeroSection  background={portfolioHero} />
                

                <section className='portfolio'>
                <Container>
                    <ul className="breadcrumbs" style={{marginBottom: '0'}}>
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/case-studies/" className="current">Case Studies</Link></li>
                    </ul>
                    </Container>
                    <h2 className="second-title"><i className="fa fa-circle"></i> <span> Case Studies </span><i className="fa fa-circle"></i></h2>
                    <Container>
                         <Row className="row-eq-height">
                        <Col col='md-5 12' className="no-padding">
                            <Slide left>
                                <div className="portfolio-image first">
                                    <img src={sample1}/>
                                    <div className="protfolio-hover">
                                        <div className="hover-content">
                                            <h3 className="portfolio-title">MTN INFO SPORT</h3>
                                            <p className="portfolio-description">
                                                 Moobifun has partnered with a leading sports content provider, to offer mobile operators Infosport service (exclusive sports news to customers on a subscription basis).
                                            </p>
                                            <Link to="/infosport/" className="portfolio-link main-btn">Read More</Link>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                        </Col>
                        <Col col='md-7 12'>
                            <Slide right>
                                <div className="portfolio-image second">
                                    <img src={sample2}/>
                                    <div className="protfolio-hover">
                                        <div className="hover-content">
                                            <h3 className="portfolio-title">Gaming: MOJA1 </h3>
                                            <p className="portfolio-description">
                                                MOJA1 is a specialist provider of financial technology and mobile money products and services in Africa. We have worked in partnership with MOJA1 from the outset of their mobile and online lotteries, games of chance and sports betting businesses in Africa.
                                            </p>
                                            <Link to="/moja/" className="portfolio-link main-btn">Read More</Link>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                        </Col>
                    </Row>
                    <Row style={{marginTop: "20px"}}>
                        <Col col='12'>
                            <Slide right>
                                <div className="portfolio-image">
                                    <img src={sample4}/>
                                    <div className="protfolio-hover">
                                        <div className="hover-content">
                                            <h3 className="portfolio-title">France Media Monde </h3>
                                            <p className="portfolio-description">
                                                Moobifun has partnered with France Media Monde to offer mobile operators a fully managed subscription news service in Senegal and the Ivory Coast.
                                            </p>
                                            <Link to="/fmd/" className="portfolio-link main-btn">Read More</Link>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                        </Col>
                    </Row>
                    </Container>
                </section>
                <Footer />
            </div>
        );
    }
}
export default PortfolioPage;
